import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'software-sob-demanda',
  templateUrl: './software-sob-demanda.component.html',
  styleUrls: ['./software-sob-demanda.component.css']
})
export class SoftwareSobDemandaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
